export default __webpack_public_path__ + "static/media/hall1.7b42028f.jpeg";